import { forwardRef } from "react";

import { useTheme } from "@mui/material";

import {
  BaseFormPaymentMethod,
  BaseFormPaymentMethodProps,
} from "@/forms-design-system/FormPaymentMethod/BaseFormPaymentMethod";
import { InvalidThemeErrorMessage } from "@/forms-design-system/InvalidThemeErrorMessage";
import { useTranslate } from "@/hooks/useTranslate";
import { StripeCard } from "@/icons/external";

type CreditCardFormPaymentMethodProps = Omit<BaseFormPaymentMethodProps, "icon" | "label">;

export const CreditCardFormPaymentMethod = forwardRef<HTMLDivElement, CreditCardFormPaymentMethodProps>(
  ({ ...rest }, ref) => {
    const theme = useTheme();
    const { t } = useTranslate();

    if (!theme.palette.forms || !theme.palette.formsComponents?.paymentMethod) {
      return <InvalidThemeErrorMessage />;
    }

    return (
      <BaseFormPaymentMethod ref={ref} icon={<StripeCard />} label={t("common", "paymentMethod.card")} {...rest} />
    );
  }
);

CreditCardFormPaymentMethod.displayName = "CreditCardFormPaymentMethod";
